import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSubHeader,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
  Separator,
  theme,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { CreateRodRequestErrorProps } from './types';
import { CreateRodRequestCaddyErrorCode } from '@bechtel/types';
import { map } from 'lodash';

const getErrorMessage = (error: CreateRodRequestErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case CreateRodRequestCaddyErrorCode.COMMENT_TOO_LARGE:
      return <Trans>Comment is too large for the following caddies.</Trans>;
    case CreateRodRequestCaddyErrorCode.CREATE_ROD_REQUEST_CADDY_ERRORED:
      return <Trans>An error has occured for the following caddies.</Trans>;
    case CreateRodRequestCaddyErrorCode.INVALID_ROD_ROOM_ID:
      return <Trans>Invalid Rod Room ID.</Trans>;
    case CreateRodRequestCaddyErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    case CreateRodRequestCaddyErrorCode.SERVICE_PROXY_ERROR:
      return <Trans>Service proxy error for the following caddies.</Trans>;
    case CreateRodRequestCaddyErrorCode.CADDY_ALREADY_ISSUED:
      return <Trans>The following caddies were not able to be issued.</Trans>;
    case CreateRodRequestCaddyErrorCode.STENCIL_EMPTY:
      return <Trans>Stencils are not selected/empty.</Trans>;
    default:
      return <Trans>An error has occured for the following caddies. Please click close button and try again.</Trans>;
  }
};

export const CreateRodRequestCaddyError: FC<CreateRodRequestErrorProps> = ({ error, onClose, errorCaddies }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Rod Request Error`}>
        <ModalClose onClick={onClose}></ModalClose>
      </ModalHeader>
      {errorCaddies ? (
        <>
          <ModalSubHeader>
            <Text size="400">
              <Trans>{getErrorMessage(errorCaddies[0].errorCode)}</Trans>
            </Text>
          </ModalSubHeader>
          <ModalBody>
            <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
              {map(errorCaddies, (caddy) => (
                <Box flexDirection={{ sm: 'column' }}>
                  <Box p={{ sm: '500' }}>
                    <Text weight="600" color="grey.1000">
                      {caddy?.caddy?.label}
                    </Text>
                  </Box>
                  <Separator spacing="000" color="grey.200" size="100%" />
                </Box>
              ))}
            </Box>
          </ModalBody>
        </>
      ) : (
        <ModalBody>
          <Text size="500">
            <Trans>{getErrorMessage(error)}</Trans>
          </Text>
        </ModalBody>
      )}
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button
              appearance={ButtonAppearance.SECONDARY}
              onClick={onClose}
              css={`
                padding: 0 ${theme.spacings[500]} 0 ${theme.spacings[500]};
              `}
            >
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
